export default "__VITE_ASSET__237db6c6__"